import classNames from 'classnames'
import React, { ReactNode } from 'react'
import pluralize from 'pluralize'
import { ClassValue } from 'classnames/types'

const countString = (count: number, base: string): string => {
    return `${count ? count + 'x' : ''} ${pluralize(base, count)}`
}

export const FeatureBadge = ({ count = null }) => {
    if (count === 0) {
        return null
    }

    return (
        <Badge className="bg-green-50 border-1 border-green-300">
            {countString(count ?? 0, 'Feature')}
        </Badge>
    )
}

export const UpdateBadge = ({ count = null }) => {
    if (count === 0) {
        return null
    }

    return (
        <Badge className="bg-blue-50 border-1 border-blue-300">
            {countString(count ?? 0, 'Update')}
        </Badge>
    )
}

export const BugFixBadge = ({ count = null }) => {
    if (count === 0) {
        return null
    }

    return (
        <Badge className="bg-red-50 border-1 border-red-300">
            {countString(count ?? 0, 'Bugfix')}
        </Badge>
    )
}

interface BadgeProps {
    className: ClassValue
    children: ReactNode
}

const Badge = ({ className, children }: BadgeProps) => {
    return (
        <span className={classNames('px-2.5 py-1.5 font-normal rounded-full', className)}>
            {children}
        </span>
    )
}
